import type { TrustUnavailableLabel } from "./terminology";
import { LABEL } from "./terminology";

export function trustValue(
  raw: string | null | undefined,
  unavailable: TrustUnavailableLabel = LABEL.unknown,
): string {
  const text = (raw ?? "").trim();
  if (!text) return unavailable;
  const lower = text.toLowerCase();
  if (
    lower === "unknown" ||
    lower === "none" ||
    lower === "null" ||
    lower === "n/a" ||
    lower === "—"
  ) {
    return unavailable;
  }
  return text;
}

export function formatTimestamp(iso: string | null | undefined): string {
  if (!iso) return LABEL.unknown;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return LABEL.unknown;
  return d.toLocaleString();
}

/** Deploy / build timestamps — missing → Not available (never Unknown). */
export function formatDeployTimestamp(iso: string | null | undefined): string {
  if (!iso) return LABEL.notAvailable;
  const text = String(iso).trim();
  if (!text) return LABEL.notAvailable;
  const lower = text.toLowerCase();
  if (
    lower === "unavailable" ||
    lower === "unknown" ||
    lower === "none" ||
    lower === "not available"
  ) {
    return LABEL.notAvailable;
  }
  const d = new Date(text);
  if (Number.isNaN(d.getTime())) return text;
  return d.toLocaleString();
}

/**
 * Subscription has no verified Control Plane API.
 * @deprecated Removed from TCC Overview / Tenant Overview — reserved for a future billing API.
 */
export function deriveSubscription(): string {
  return LABEL.notConfigured;
}

export type SecretRow = {
  id: string;
  name: string;
  masked: string;
  lastRotated: string;
  lastUsed: string;
  status?: string;
  ageDays?: number | null;
};

/**
 * Offline placeholder when secrets API is unavailable.
 * Prefer GET /api/customers/{slug}/secrets in Control Plane UI.
 */
export function deriveSecrets(): SecretRow[] {
  return [
    {
      id: "api_secret",
      name: "API Secret",
      masked: "••••••••••••••••",
      lastRotated: LABEL.notAvailable,
      lastUsed: LABEL.notAvailable,
      status: "missing",
    },
    {
      id: "webhook_secret",
      name: "Webhook Secret",
      masked: "••••••••••••••••",
      lastRotated: LABEL.notAvailable,
      lastUsed: LABEL.notAvailable,
      status: "missing",
    },
    {
      id: "jwt_secret",
      name: "JWT Secret",
      masked: "••••••••••••••••",
      lastRotated: LABEL.notAvailable,
      lastUsed: LABEL.notAvailable,
      status: "missing",
    },
    {
      id: "encryption_key",
      name: "Encryption Key",
      masked: "••••••••••••••••",
      lastRotated: LABEL.notAvailable,
      lastUsed: LABEL.notAvailable,
      status: "missing",
    },
  ];
}
